<template>
  <div>
    <div class="row">
      <div class="col-12 font-weight-medium font-size-16">
        Escalation setting
      </div>
      <div class="col-12 col-md-6 mt-1">
        <atom-select
          v-model="escalation"
          title="Escalation Template"
          placeholder="Select Template"
          label="name"
          :option="escalationTemplateList"
          :is-disable="isDisableSelect || !hasUpdatePermission"
          :is-clearable="!isDisableSelect && hasUpdatePermission"
          @input="$emit('changeEscalationTemplate', $event)"
        />
      </div>
    </div>
    <div v-if="escalationName" class="row mt-3">
      <div class="col-12 font-weight-semibold">{{ escalationName }}</div>
      <div class="col-12 mt-1">
        {{ description }}
      </div>
    </div>
    <div v-if="levels.length" class="row">
      <div class="col-12 mt-1">
        <molecule-escalation-item
          v-for="escalationItem in levels"
          :key="escalationItem.id"
          :escalation="escalationItem"
          :is-show-info="isShowInfo"
          :hasUpdatePermission="hasUpdatePermission"
          @onClickEscalateLevel="$emit('onClickEscalateLevel')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeEscalationItem from "./MoleculeEscalationItem.vue"

export default {
  name: "MoleculeEscalationSelection",
  components: { AtomSelect, MoleculeEscalationItem },
  emits: ["onClickEscalateLevel"],
  props: {
    escalationTemplateList: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: null,
    },
    escalationName: {
      type: String,
      required: false,
      default: "",
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    levels: {
      type: Array,
      required: false,
      default: () => [],
    },
    isShowInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisableSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    escalation: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
